import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { TaskTemplateVersion } from '@core/entities/task/TaskTemplateVersion'
import {
  taskTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/tasks/templates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateTaskTemplateVersion = (
  options?: UseMutationOptions<
    TaskTemplateVersion,
    RequestErrorType,
    RequestTypes['createTaskTemplateVersion']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...taskTemplateKeys.createTaskTemplateVersion,
    ...options,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: taskTemplateKeys.getTaskTemplateVersions({
          templateId: variables.templateId,
        }).queryKey,
      })
    },
  })
}
